module.exports = __webpack_public_path__ + "images/category_lp/musical_instrument/new/assessment_achievements/1@2x_cbd5434724a41d848ece1a5deaa93a25.png";